"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        label: 'Username',
        key: 'username',
        required: true,
        placeholder: 'Username',
        displayOrder: 1,
    },
    {
        label: 'Password',
        key: 'password',
        required: true,
        placeholder: 'Password',
        type: 'password',
        displayOrder: 2,
    },
    {
        label: 'Email',
        key: 'email',
        required: true,
        placeholder: 'Email',
        type: 'email',
        displayOrder: 3
    },
    {
        label: 'Mobile Number',
        key: 'phone_number',
        placeholder: 'Mobile Number',
        required: true,
        displayOrder: 4
    }
];
exports.signUpWithEmailFields = [
    {
        label: 'Email',
        key: 'email',
        required: true,
        placeholder: 'Email',
        type: 'email',
        displayOrder: 1
    },
    {
        label: 'Password',
        key: 'password',
        required: true,
        placeholder: 'Password',
        type: 'password',
        displayOrder: 2,
    },
    {
        label: 'Mobile Number',
        key: 'phone_number',
        placeholder: 'Mobile Number',
        required: true,
        displayOrder: 3
    }
];
exports.signUpWithPhoneNumberFields = [
    {
        label: 'Mobile Number',
        key: 'phone_number',
        placeholder: 'Mobile Number',
        required: true,
        displayOrder: 1
    },
    {
        label: 'Password',
        key: 'password',
        required: true,
        placeholder: 'Password',
        type: 'password',
        displayOrder: 2,
    },
    {
        label: 'Email',
        key: 'email',
        required: true,
        placeholder: 'Email',
        type: 'email',
        displayOrder: 3
    },
];
//# sourceMappingURL=default-sign-up-fields.js.map